/**
* A Scrollable table that shows info about recent deposits.
*/

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ScrollableTablePanel from 'components/ScrollableTablePanel';
import { formatters } from 'common';
import messages from './messages';


const RecentDepositsPanel = ({ recentDeposits }) => {
  const columns = [
    { name: 'bankAccountNumber', label: <FormattedMessage {...messages.bankAccount} /> },
    { name: 'routingNumber', label: <FormattedMessage {...messages.routingNumber} /> },
    { name: 'amount', label: <FormattedMessage {...messages.amount} /> },
    { name: 'date', label: <FormattedMessage {...messages.transferDate} /> },
  ];
  const rows = recentDeposits.map((recentDeposit) => ({
    ...recentDeposit,
    amount: formatters.formatDollars(recentDeposit.amount),
  }));

  return (<ScrollableTablePanel columns={columns} rows={rows} />);
};

RecentDepositsPanel.propTypes = {
  recentDeposits: PropTypes.arrayOf(PropTypes.shape({
    amount: PropTypes.number.isRequired,
    bankAccountNumber: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    routingNumber: PropTypes.string.isRequired,
  })).isRequired,
};

export default RecentDepositsPanel;



// WEBPACK FOOTER //
// ./src/components/RecentDepositsPanel/index.js